/**
 * @fileoverview Initializes and exports Firebase `app`, `auth`, `db` (Firestore), and `functions` instances. Connects to Firebase emulators locally in development using `connectAuthEmulator`, `connectFirestoreEmulator`, and `connectFunctionsEmulator`. Uses `initializeApp`, `getAuth`, `getFirestore`, and `getFunctions` from the Firebase SDK.
 */

import { initializeApp } from 'firebase/app'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions'
import { isDev } from './utils/env'

// Firebase configuration from the environment
// These values should be provided based on your Firebase console
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

// Initialize Firebase
export const app = initializeApp(firebaseConfig)

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app)

// Initialize Firestore
export const db = getFirestore(app)

// Initialize Firebase Functions
export const functions = getFunctions(app)

// Connect to emulators only in development mode (not staging or production)
if (isDev()) {
  connectAuthEmulator(auth, 'http://localhost:9099')
  connectFirestoreEmulator(db, 'localhost', 8080)
  connectFunctionsEmulator(functions, 'localhost', 5001)
}
